import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    hideMenu: [],
    buttonMenu: []
  },
  mutations: {
    setHideMenu(state, hideMenu) {
      state.hideMenu = hideMenu;
    },
    setButtonMenu(state, buttonMenu) {
      state.buttonMenu = buttonMenu;
    },
  },
  actions: {
    // getExtendStatus({ state }) {
    //   http.get({ modules: "bridgeStatus" }).then(data => {
    //     //data.bridgeStatus.extended = 3;
    //     state.extendStatus = +data.bridgeStatus.extended;
    //   });
    // }
  }
});
